import { useEffect } from 'react';

export const useClickOutside = nextBtnRef => {
  const exceptionSelectors = [
    '#user-email',
    '[class*=login-logout-btn]',
    '.close-wrapper-btn',
    'img[alt="close-icon"]',
    '[src$="close.svg"]',
    '.coupon-section *',
    '.order-notes-button',
    '#note',
    '.plugin-button *',
    '.links a',
    '.warn-terms *',
    '.mini-cart-btn',
    '.mini-cart-btn *',
  ];

  const sidebarSelector = '.app-sidebar';
  const sidebarAndAllInsideSelector = '.app-sidebar *';
  const activeSidebarSelector = '.active.app-sidebar';
  const activeSidebarBeforeSelector = '.app-sidebar.active:before';

  useEffect(() => {
    const handleClickOutside = e => {
      const isSidebarInTheExceptionList = exceptionSelectors.includes(sidebarAndAllInsideSelector);
      const isSidebarActiveInMobile = document.querySelector(activeSidebarSelector) !== null;
      if (isSidebarActiveInMobile && !isSidebarInTheExceptionList) {
        exceptionSelectors.push(sidebarAndAllInsideSelector);
        exceptionSelectors.push(sidebarSelector);
        exceptionSelectors.push(activeSidebarBeforeSelector);
      }
      const isException = exceptionSelectors.some(selector => e.target.matches(selector));
      if (nextBtnRef.current && !isException) {
        nextBtnRef.current.click();
      }
    };

    document.body.addEventListener('click', handleClickOutside);

    return () => {
      document.body.removeEventListener('click', handleClickOutside);
    };
  }, [nextBtnRef]);
};
